<template>
  <b-dropdown scrollable v-model="selected" ref="dropdown" mobile-modal>
    <template #trigger>
      <TriggerButton>
        <template v-if="selected === null">
          {{ label }}
        </template>
        <template v-else>
          {{ selected }}
        </template>
      </TriggerButton>
    </template>
    <template v-if="hasManyItems">
      <b-dropdown-item custom :focusable="false">
        <ResetButton @click="reset" />
      </b-dropdown-item>
      <b-dropdown-item separator />
    </template>
    <b-dropdown-item
      v-for="item in items"
      :key="item.value"
      :value="item.value"
      focusable
    >
      <span :class="{ 'has-text-weight-bold': item === selected }">
        {{ replace(item.value) }} ({{ item.count }})
      </span>
    </b-dropdown-item>
    <template>
      <b-dropdown-item separator />
      <b-dropdown-item custom :focusable="false">
        <ResetButton @click="reset" />
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
import TriggerButton from "./TriggerButton.vue";
import ResetButton from "./ResetButton.vue";

import omit from "lodash/omit";

export default {
  components: {
    TriggerButton,
    ResetButton,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    // name for url param
    name: {
      type: String,
      required: true,
    },
  },
  watch: {
    //    '$route.query': {
    //      handler(query) {
    //        console.log('watch')
    //        console.log(query)
    //        console.log(this.name)
    //  const value = query[this.name]

    //  if (this.isValid(value)) {
    //    this.selected = this.items.filter(
    //      (item) => item.key == value
    //    ).pop() || null
    //  }
    //  else {
    //    // clear invalid param
    //    this.$router.push({ query: omit(this.$route.query, this.name) })
    //  }
    //      },
    //      immediate: true
    //    },
    selected(item) {
      let query = { ...this.$route.query };
      console.log(query);
      if (item !== null) {
        query[this.name] = item;
      } else {
        query = omit(query, this.name);
      }

      this.$router.push({ query });
    },
  },
  data: () => ({
    selected: null,
  }),
  computed: {
    hasManyItems() {
      return this.items.length > 10;
    },
  },
  methods: {
    isValid(value) {
      // NOTE: does not check for correct type
      return this.items.some((item) => item == value);
    },
    replace(value){
      return value.replace('u0020','');
    },
    reset() {
      this.selected = null;
      if (this.$refs.dropdown) {
        this.$refs.dropdown.toggle();
      }
    },
  },
};
</script>
